import { useUnsavedChanges } from 'components/prescription/UnsavedChangesContext';
import React, { useEffect, useState } from 'react';
import { Breadcrumb } from 'react-bootstrap';

const CommonBreadCrumb = ({ breadcrumbItems }) => {
  const [themeClass, setThemeClass] = useState('bg-light text-dark');
  const { isDirty, setIsDirty } = useUnsavedChanges();

  useEffect(() => {
    const getTheme = () => {
      const theme = document.documentElement.getAttribute('data-bs-theme');
      return theme === 'dark'
        ? 'bg-dark text-light border border-secondary'
        : 'bg-light text-dark';
    };

    setThemeClass(getTheme());
    const observer = new MutationObserver(() => {
      setThemeClass(getTheme());
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-bs-theme'],
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (!isDirty) return;

      if (e.target.tagName === "A") {
        const confirmLeave = window.confirm(
          "You have unsaved changes. Are you sure you want to leave?"
        );
        if (confirmLeave) {
          setIsDirty(false);
        }
        
        if (!confirmLeave) {
          e.preventDefault();
          return false;
        }
        console.log("confirmLeave", confirmLeave);
      }
    };

    window.addEventListener("click", handleBeforeUnload);

    return () => {
      window.removeEventListener("click", handleBeforeUnload);
    };
  }, [isDirty]);

  return (
    <Breadcrumb className={`breadcrumb px-3 py-2 rounded mb-2 ${themeClass}`}>
      {breadcrumbItems.map((item, index) => (
        <React.Fragment key={index}>
          <Breadcrumb.Item
            href={item.href}
            active={item.isActive}
            className={
              item.isActive
                ? 'text-secondary'
                : themeClass.includes('bg-dark')
                ? 'text-info fw-bold'
                : 'text-primary fw-bold'
            }
          >
            {item.name}
          </Breadcrumb.Item>
          {index < breadcrumbItems.length - 1 && (
            <span className="mx-1 text-secondary">{'>'}</span>
          )}
        </React.Fragment>
      ))}
    </Breadcrumb>
  );
};

export default CommonBreadCrumb;
